<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px">
                <col>
            </colgroup>
            <tr>
                <td class="c_t_title">제목</td>
                <td>
                    <div class="d_block">
                        <el-input v-model="title" @input="parentChange('title', title)"></el-input>
                        <div class="input_error">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">채널 이미지</td>
                <td>
                    <div class="d_block">
                        <el-upload
                                action=""
                                class="avatar-uploader channel_img"
                                list-type="picture-card"
                                :auto-upload="false"
                                :show-file-list="false"
                                :file-list="files"
                                :on-change="onlyOnePhotoChange"
                                style="display: inline-block"
                        >
                            <i class="el-icon-plus avatar-uploader-icon"
                               v-if="files.length === 0"></i>
                            <div v-else>
                                <img :src="files[0].org_url" alt="" class="avatar">
                            </div>
                            <div class="el-upload__tip" style="font-size:14px; color:red;"
                                 slot="tip">권장이미지: 105px * 105px
                            </div>
                        </el-upload>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">채널 소개</td>
                <td>
                    <div class="d_block">
                        <el-input type="textarea" v-model="channelInfo"
                                  style="width: 100%; height: 130px;" resize="none"
                                  @input="parentChange('channelInfo', channelInfo)"></el-input>
                        <div class="input_error">{{ validation.firstError('channelInfo') }}</div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">URL</td>
                <td>
                    <div class="d_block">
                        <el-input v-model="channelUrl" @input="parentChange('channelUrl', channelUrl)"></el-input>
                        <div class="input_error">{{ validation.firstError('channelUrl') }}</div>
                    </div>
                </td>
            </tr>
        </table>
    </div>

</template>

<script>
import summernote from '@/mixins/summernote';
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import elFileMixins from "@/mixins/elFileMixins";
import lookbookValidator from "@/mixins/validators/LookbookValidator";

export default {
    name: "LookbookWriteChannelLayout",
    mixins: [summernote, elFileMixins, lookbookValidator],
    components: {},
    inject: ['lookbookWriteSetData'],
    provide() {
        return {}
    },
    props: {
        lookbookData: {
            default: () => {
            }
        },
        channelData: {default: () => []},
    },
    data() {
        return {
            fixCheck: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            hashList: [],
        }
    },
    created() {
    },
    mounted() {
        EventBus.$on('LookbookWriteChannelLayoutValidator', this.checkValidator)
        this.setInitData();
    },
    beforeDestroy() {
        EventBus.$off('LookbookWriteChannelLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        parentChange(type, value) {
            this.lookbookWriteSetData(type, value);
        },
        hasLookbookData() {
            return !util.isEmpty(this.lookbookData)
        },

        setInitData() {
            if (this.hasLookbookData()) {
                this.title = this.lookbookData.lc_title;
                this.parentChange('title', this.title)

                this.channelInfo = this.lookbookData.lc_content;
                this.parentChange('channelInfo', this.channelInfo)

                if (this.lookbookData.hasOwnProperty('ChannelFile') && this.lookbookData.ChannelFile.length > 0) {
                    this.files = this.lookbookData.ChannelFile
                    this.parentChange('files', this.files);
                }

                this.channelUrl = this.lookbookData.lc_url;
                this.parentChange('channelUrl', this.channelUrl)
            }
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
